import './../../scss/blocks/_order.scss'

import orderModal from '../components/orderModal'
import { initFormValidation } from '../components/form'

document.addEventListener('DOMContentLoaded', () => {
    orderModal()
    initFormValidation()
})
